import { observable, action, computed } from 'mobx';

export enum View {
	Scanner,
	Settings
}

export interface ICommonStore {
	appLoaded: boolean;
	view: View;
	isMobile: boolean;	
	setIsMobile(width: number): void;
	darkTheme: boolean;
	storeTheme(darkTheme: boolean): void;
}

class CommonStore implements ICommonStore {

	@observable appLoaded = false;
	@observable view: View = View.Scanner;
	@observable isMobile: boolean = false;
	@observable darkTheme: boolean = this.theme;

	setIsMobile(width: number): void {
		this.isMobile = width < 768;
	}

	@action storeTheme(darkTheme: boolean): void {
		window.localStorage.setItem('darkTheme', darkTheme + '');		
	}

	@computed get theme(): boolean {
		return window.localStorage.getItem('darkTheme') == 'true';
	}	
}

export default new CommonStore();